import {i18n} from '@netx/core/i18n';

export let typeIds = {
	export: 'export',
	import: 'import',
	both: 'both',
};

export let typeLabels = {
	both: i18n.t('i18n.roundTrip'),
	export: i18n.t('i18n.export'),
	import: i18n.t('i18n.import'),
};

// Because figuring out a custom value is not easy
export let map = {
	cdr: 'Corel cdr',
	cdrinfo: 'Corel cdrinfo',
	cdt: 'Corel cdt',
	crl: 'Corel',
	dc: 'Dublin Core',
	DICOM: 'Dicom',
	exif: 'EXIF',
	fill: 'Corel Fill',
	ID3: 'ID3',
	Iptc4xmpCore: 'IPTC',
	Iptc4xmpExt: 'IPTC',
	pdf: 'PDF',
	photoshop: 'Photoshop',
	tiff: 'EXIF',
	xmp: 'XMP',
	xmpDM: 'XMP',
	xmpMM: 'XMP',
	xmpRights: 'XMP',
};

export let types = _.invert(typeIds);

// This is for dropdowns
export let typeOptions = _.mapObject(types, (name) => typeLabels[name]);

export default {
	map: map,
	typeIds: typeIds,
	typeLabels: typeLabels,
	typeOptions: typeOptions,
	types: types,
};
